exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\r\n\r\n.turbo-mode_turbo-container_1qQFO {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 0.25rem;\r\n    -webkit-user-select: none;\r\n       -moz-user-select: none;\r\n        -ms-user-select: none;\r\n            user-select: none;\r\n}\r\n\r\n.turbo-mode_turbo-icon_A_vJA {\r\n    margin: 0.25rem;\r\n}\r\n\r\n.turbo-mode_turbo-label_1v23d {\r\n    font-size: 0.625rem;\r\n    font-weight: bold;\r\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\r\n    color: var(--control-primary);\r\n    white-space: nowrap;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"turbo-container": "turbo-mode_turbo-container_1qQFO",
	"turboContainer": "turbo-mode_turbo-container_1qQFO",
	"turbo-icon": "turbo-mode_turbo-icon_A_vJA",
	"turboIcon": "turbo-mode_turbo-icon_A_vJA",
	"turbo-label": "turbo-mode_turbo-label_1v23d",
	"turboLabel": "turbo-mode_turbo-label_1v23d"
};